import { ComponentFactoryResolver, ComponentRef, Injectable, Injector, Type, ViewContainerRef } from '@angular/core';

interface LayoutElements {
  [name: string]: ViewContainerRef;
}

interface ComponentPayload {
  [key: string]: any;
}

interface ComponentRefs {
  [name: string]: ComponentRef<any>;
}

@Injectable()
export class PageCabinetService {
  private layoutElements: LayoutElements = Object.create(null);
  private injector: Injector;
  private componentFactoryResolver: ComponentFactoryResolver;
  private componentRef: ComponentRefs = Object.create(null);

  setLayoutElements(layoutElements: LayoutElements): void {
    this.layoutElements = {
      ...this.layoutElements,
      ...layoutElements,
    };
  }

  setContext(injector: Injector, resolver: ComponentFactoryResolver): void {
    this.injector = injector;
    this.componentFactoryResolver = resolver;
  }

  setBottomComponent(component: Type<any>, payload: ComponentPayload): void {
    this.setComponent('bottom', component, payload);
  }

  clearBottomComponent(): void {
    this.clearComponent('bottom');
  }

  private setComponent(layoutElementName: string, component: Type<any>, payload: ComponentPayload): void {
    this.clearComponent(layoutElementName);

    this.createComponent(layoutElementName, component);

    this.setPayload(layoutElementName, payload);
  }

  private clearComponent(layoutElementName: string): void {
    this.checkLayoutElementExistence(layoutElementName);

    this.layoutElements[layoutElementName].clear();

    if (this.componentRef[layoutElementName]) {
      this.componentRef[layoutElementName].destroy();
    }
  }

  private checkLayoutElementExistence(layoutElementName: string): void {
    if (!this.layoutElements[layoutElementName]) {
      throw new ReferenceError(`Layout element ${layoutElementName} does not exist`);
    }
  }

  private createComponent(layoutElementName: string, component: Type<any>): void {
    const refInjector: Injector = Injector.create({
      providers: [{ provide: component, useValue: component }],
      parent: this.injector,
    });
    const childComponent = this.componentFactoryResolver.resolveComponentFactory(component);

    this.componentRef[layoutElementName] = this.layoutElements[layoutElementName].createComponent(
      childComponent,
      0,
      refInjector,
    );
  }

  private setPayload(layoutElementName: string, payload: ComponentPayload): void {
    Object.keys(payload).forEach(key => {
      this.componentRef[layoutElementName].instance[key] = payload[key];
    });
  }
}
